export default "__VITE_ASSET__3c829216__"